/**
 * Sentry doit être initialisé AVANT tout autre code.
 * Ce fichier est importé en premier dans index.js.
 */
import * as Sentry from '@sentry/react';
import axios from 'axios';
import history from './history/history';

// URLs pour la propagation des traces (frontend → backend)
const traceTargets = [
  'localhost',
  /^https?:\/\/localhost(:\d+)?/,
  /^https?:\/\/127\.0\.0\.1(:\d+)?/,
];
const apiUrl = process.env.REACT_APP_URL_BACKEND || process.env.REACT_APP_PROXY || 'http://localhost:7200';
try {
  const url = new URL(apiUrl);
  traceTargets.push(url.origin);
  traceTargets.push(new RegExp(`^https?:\\/\\/${url.hostname}(:\\d+)?`));
} catch (e) {
  traceTargets.push(apiUrl);
}

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN || 'https://98e4f8b0f3fd85dc48d738c5b4baa5f2@sentry.mjb.ovh/23',
  environment: process.env.NODE_ENV || process.env.REACT_APP_SENTRY_ENV || 'development',
  release: process.env.REACT_APP_SENTRY_RELEASE,
  tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 0.5,
  tracePropagationTargets: traceTargets,
  maxBreadcrumbs: 50,
  attachStacktrace: true,
  integrations: [
    Sentry.reactRouterV4BrowserTracingIntegration({ history }),
    Sentry.feedbackIntegration({
      colorScheme: 'system',
      autoInject: true,
      showBranding: false,
      enableScreenshot: true,
      addScreenshotButtonLabel: "Ajouter une capture d'écran",
      removeScreenshotButtonLabel: "Supprimer la capture d'écran",
      buttonLabel: 'Signaler un bug',
      formTitle: 'Signaler un bug',
      submitButtonLabel: 'Envoyer le rapport',
      cancelButtonLabel: 'Annuler',
      nameLabel: 'Nom',
      namePlaceholder: 'Votre nom',
      emailLabel: 'Email',
      emailPlaceholder: 'votre.email@exemple.com',
      messageLabel: 'Description',
      messagePlaceholder: "Quel est le bug ? Que s'est-il passé et à quoi vous attendiez-vous ?",
      successMessageText: 'Merci pour votre rapport !',
      confirmButtonLabel: 'Confirmer',
      isRequiredLabel: '(requis)',
      screenshotOptions: { quality: 0.8, format: 'image/png', width: window.innerWidth, height: window.innerHeight },
    }),
    Sentry.replayIntegration({
      maskAllText: false,
      maskAllInputs: true,
      blockAllMedia: false,
      mask: ['input[type="password"]', 'input[name*="password"]', '.sensitive-data', '[data-sensitive]'],
      block: ['.sentry-block', '[data-sentry-block]', '.private-content'],
      ignore: ['.sentry-ignore', '[data-sentry-ignore]'],
      stickySession: true,
      slimDOMOptions: 'all',
      inlineStylesheet: true,
      collectFonts: true,
      inlineImages: false,
    }),
  ],
});

// Intercepteur Axios : envoie les erreurs API à Sentry
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    // Ne pas capturer 401 (déconnexion / token expiré - attendu)
    if (status !== 401 && (status >= 500 || status === 0 || status == null)) {
      Sentry.captureException(error, {
        extra: {
          url: error.config?.url,
          method: error.config?.method,
          status,
        },
      });
    }
    return Promise.reject(error);
  }
);
